import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { VOID_FUNCTION } from 'constants/index';
import { insAnketaAddDriver } from 'store/insuranceAnketa';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';

import { useDisabledFields } from '../../hooks/useDisabledFields';

export const useAddDriverButtonPresenter = ({ onClick: onClickProp = VOID_FUNCTION }) => {
  const dispatch = useDispatch();

  const { disabled: pageRestrict } = useDisabledFields();

  const onClick = useCallback(() => {
    onClickProp();
    dispatch(insAnketaAddDriver(undefined, true, { [DRIVER_FIELDS.EDIT]: true }));
  }, [onClickProp]);

  return { disabled: pageRestrict, onClick };
};
